export default __webpack_public_path__ + "static/media/logo.ec609660.png";